import { render, staticRenderFns } from "./ExampleContactSettings.vue?vue&type=template&id=b5e70c42&scoped=true"
import script from "./ExampleContactSettings.vue?vue&type=script&lang=js"
export * from "./ExampleContactSettings.vue?vue&type=script&lang=js"
import style0 from "./ExampleContactSettings.vue?vue&type=style&index=0&id=b5e70c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e70c42",
  null
  
)

export default component.exports